import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import "../../styles/common/Navbar.css";
import logo from "../../assets/images/logo.svg";
import { FaUserCircle } from 'react-icons/fa';
export default function AppNavbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [walletBalance, setWalletBalance] = useState(null);
  
  const notifRef = useRef(null);
  const profileRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();
  const UserDetails = sessionStorage.getItem("userDetails") || localStorage.getItem("userDetails");
  const parsedUserDetails = UserDetails ? JSON.parse(UserDetails) : null;
  const roleLabel = parsedUserDetails?.role === "subadmin" ? "Coordinate Agent" : parsedUserDetails?.role;
const profilePicture = null; 
  const toggle = () => setIsOpen(!isOpen);

  useEffect(() => {
    const updateAuthStatus = () => {
      const token = sessionStorage.getItem("token") || localStorage.getItem("token");
      const role = sessionStorage.getItem("role") || localStorage.getItem("role");
      setIsLoggedIn(!!token);
      setUserRole(role);
    };

    updateAuthStatus();

    const fetchNotifications = async () => {
      const token = sessionStorage.getItem("token") || localStorage.getItem("token");
      const role = sessionStorage.getItem("role") || localStorage.getItem("role");
      const API_BASE = process.env.REACT_APP_API_URL ;
      if (token && role) {
        try {
          let path = null;
          const r = (role || '').toLowerCase();
          if (r === 'admin') path = '/admin/notifications';
          else if (r === 'superadmin') path = '/superadmin/notifications';
          else if (r === 'orguser') path = '/orguser/notifications';
          else {
            setNotifications([]);
            return;
          }
          const response = await axios.get(
            `${API_BASE}${path}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const payload = response.data;
          const list = Array.isArray(payload?.data) ? payload.data : [];
          const mapped = list.map(n => ({
            id: n.id,
            type: n.type,
            title: n.title,
            message: n.message,
            isRead: n.isRead,
            createdAt: n.createdAt,
            organizationName: n.organization?.organizationName,
          }));
          // Only show unread notifications in badge
          setNotifications(mapped.filter(n => !n.isRead));
        } catch (err) {
          console.error("Failed to fetch notifications:", err);
          setNotifications([]);
        }
      }
    };

    const fetchWalletBalance = async () => {
      const token = sessionStorage.getItem("token") || localStorage.getItem("token");
      const role = sessionStorage.getItem("role") || localStorage.getItem("role");
      const API_BASE = process.env.REACT_APP_API_URL;
      
      if (token && role?.toLowerCase() === 'orguser') {
        try {
          const response = await axios.get(
            `${API_BASE}/orguser/wallet`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          // Handle different response structures
          if (response.data?.data?.balance !== undefined) {
            setWalletBalance(response.data.data.balance);
          } else if (response.data?.balance !== undefined) {
            setWalletBalance(response.data.balance);
          }
        } catch (err) {
          console.error("Failed to fetch wallet balance:", err);
        }
      }
    };

    fetchNotifications();
    fetchWalletBalance();
    
    // Auto-refresh notifications and wallet every 30 seconds
    const pollInterval = setInterval(() => {
      fetchNotifications();
      fetchWalletBalance();
    }, 30000);
    
    const handleStorageChange = () => {
      updateAuthStatus();
      fetchNotifications();
      fetchWalletBalance();
    };
    window.addEventListener("storage", handleStorageChange);
    
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(pollInterval);
    };
  }, [location.pathname]);

  // Close dropdowns on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notifRef.current && !notifRef.current.contains(event.target)) {
        setNotifOpen(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

   const handleNavClick = () => {
    setIsOpen(false); // Close the collapse menu when a link is clicked
  };
  const handleLogout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("userDetails");
    // fallback
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    setIsLoggedIn(false);
    setUserRole(null);
    navigate("/login");
  };

  const scrollToSection = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: sectionId } });
    } else {
      const element = document.getElementById(sectionId);
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const showWallet = isLoggedIn && (userRole === "orguser" || userRole === "user");
  const profilePath =
    userRole === "superadmin" ? "/super-admin/profile" 
    : userRole === "subadmin" ? "/sub-admin/profile"
    : `/${userRole}/profile`;
  
  const notificationsPath =
    userRole?.toLowerCase() === "superadmin" ? "/super-admin/notifications"
    : userRole?.toLowerCase() === "admin" ? "/admin/notifications"
    : userRole?.toLowerCase() === "orguser" ? "/orguser/notifications"
    : null;

  return (
    <div className="nav-container">
      <div className="container-fluid nav-wrapper">
        <Navbar expand="md" light className="p-0 w-100">
          {/* Logo + Toggler */}
          <div className="d-flex w-100 justify-content-between align-items-center">
            <NavbarBrand  className="nav-logo-link">
              <img src={logo} alt="Logo" className="logo-image" />
            </NavbarBrand>

            <NavbarToggler
              onClick={toggle}
              className="border-0"
              aria-label="Toggle navigation"
            />
          </div>

          {/* Collapsible Menu (appears below logo & toggler) */}
          <Collapse isOpen={isOpen} navbar className="custom-collapse-menu">
            <Nav navbar className="ms-auto mt-3 mt-md-0 align-items-start">
              {!isLoggedIn && (
                <>
                  <NavItem>
                    <NavLink tag={Link} to="/" className={`nav-menu-link ${location.pathname === '/' ? 'active' : ''}`} onClick={handleNavClick}>
                      Home
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} to="/industries" className={`nav-menu-link ${location.pathname === '/industries' ? 'active' : ''}`} onClick={handleNavClick}>
                      Industries
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} to="/services" className={`nav-menu-link ${location.pathname === '/services' ? 'active' : ''}`} onClick={handleNavClick}>
                      Services
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} to="/how-it-works" className={`nav-menu-link ${location.pathname === '/how-it-works' ? 'active' : ''}`} onClick={handleNavClick}>
                      How It Works
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} to="/about-us" className={`nav-menu-link ${location.pathname === '/about-us' ? 'active' : ''}` } onClick={handleNavClick}>
                      About Us
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} to="/career" className={`nav-menu-link ${location.pathname === '/career' ? 'active' : ''}`} onClick={handleNavClick}>
                      Career
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} to="/faq" className={`nav-menu-link ${location.pathname === '/faq' ? 'active' : ''}`} onClick={handleNavClick}>
                      FAQ
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} to="/contact" className={`nav-menu-link ${location.pathname === '/contact' ? 'active' : ''}`} onClick={handleNavClick}>
                      Contact
                    </NavLink>
                  </NavItem>
                </>
              )}

              {showWallet && (
                <NavItem>
                  <NavLink
                    tag={Link}
                    to={`/${userRole}/wallet`}
                    className="nav-menu-link"
                  >
                    Wallet
                  </NavLink>
                </NavItem>
              )}

              {!isLoggedIn && (
                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/login"
                    className="nav-menu-link nav-login-btn"
                  >
                    Login
                  </NavLink>
                </NavItem>
              )}
            </Nav>

            {isLoggedIn && (
              <div className="nav-actions mt-3 mt-md-0">
                {/* Wallet Balance (for OrgUser only) */}
                {userRole?.toLowerCase() === 'orguser' && walletBalance !== null && (
                  <div className="nav-wallet-balance">
                    <span className="nav-wallet-icon"></span>
                    <span className="nav-wallet-amount">₹{Number(walletBalance).toFixed(2)}</span>
                  </div>
                )}

                {/* Notifications */}
                <div
                  className="nav-notification-wrapper"
                  ref={notifRef}
                  onClick={() => setNotifOpen(!notifOpen)}
                >
                  <div className="nav-notification-icon">
                    <span className="nav-bell-icon">🔔</span>
                    {notifications.filter(n => !n.isRead).length > 0 && (
                      <span className="nav-notification-badge">
                        {notifications.filter(n => !n.isRead).length}
                      </span>
                    )}
                  </div>

                  {notifOpen && (
                    <div className="nav-notification-dropdown" onClick={(e) => e.stopPropagation()}>
                      <div className="nav-notification-header">Notifications</div>
                      <div className="nav-notification-list">
                        {notifications.filter(n => !n.isRead).length === 0 ? (
                          <div className="nav-notification-item-empty">
                            No new notifications
                          </div>
                        ) : (
                          notifications.filter(n => !n.isRead).slice(0, 5).map((notif, index) => (
                            <div key={index} className="nav-notification-item">
                              <div className="nav-notification-message">
                                {notif.message}
                              </div>
                              <span className="nav-notification-time">
                                {notif.organizationName ? `Org: ${notif.organizationName}` : ''}
                              </span>
                            </div>
                          ))
                        )}
                      </div>
                      {notificationsPath && notifications.filter(n => !n.isRead).length > 0 && (
                        <div className="nav-notification-footer">
                          <Link 
                            to={notificationsPath} 
                            className="nav-notification-view-all"
                            onClick={() => setNotifOpen(false)}
                          >
                            View All Notifications
                          </Link>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Profile */}
                <div
                  className="nav-profile-wrapper"
                  ref={profileRef}
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  {/* <div className="nav-profile-avatar"> */}
                    {profilePicture ? (
                      <img
                        src={profilePicture}
                        alt="Profile"
                        className="profile-pic"
                      />
                    ) : (
                      <FaUserCircle className="dummy-profile-icon" />
                    )}
                  {/* </div> */}

                  <div className="nav-profile-info">
                    <span className="nav-profile-email">
                      {parsedUserDetails?.email}
                    </span>
                    <span className="nav-profile-role">
                      {roleLabel}
                    </span>
                  </div>

                  {dropdownOpen && (
                    <div className="nav-profile-dropdown" onClick={(e) => e.stopPropagation()}>
                      <Link to={profilePath} className="nav-profile-link" onClick={() => setDropdownOpen(false)}>
                        <span className="nav-profile-icon">👤</span>
                        My Profile
                      </Link>
                      <button onClick={handleLogout} className="nav-logout-btn">
                        <span className="nav-logout-icon">🚪</span>
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </Collapse>
          
        </Navbar>
        
      </div>
    </div>
  );
}
